import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendModel } from '../../../../../features/site/siteSlice'

import { serviceMap } from '../../../../utils/common'
import LinkedInOrgClaimCard from '../../../Admin/ServiceTypes/LinkedInOrg'

import ServiceCardBase from '../../ServiceCardBase'

function LinkedinOrg({ onSave, onCancel}){
    const dispatch = useDispatch()

    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)
    const site = model?.sites[model.siteActiveIdx]

    const { siteForm } = model

    const editSite = async() => {
        await dispatch(appendModel({
            siteForm: {
                ...siteForm,
                attr: {
                    ...siteForm.attr,
                    accounts: {
                        ...(siteForm?.attr?.accounts ?? {}),
                        linkedinOrg: undefined
                    }
                }
            }
        }))
    }

    return <ServiceCardBase 
        title="LinkedIn Organization" 
        header="LinkedIn Organization" 
        description="  "
        image={serviceMap.linkedinOrg.img}>
        <LinkedInOrgClaimCard design="onboarding" />
        <div class="d-flex flex-row-reverse justify-content-between">
            <div>
                {siteForm?.attr?.accounts?.linkedinOrg && <button className="mr-3 btn btn-lg btn-outline-primary" onClick={() => editSite()}>
                    Edit
                </button>}
                {siteForm?.attr?.accounts?.linkedinOrg && oauthTokens.linkedinOrg && <button id="saveLinkedinOrg" className="btn btn-lg btn-primary" onClick={async() => {
                    await onSave("linkedinOrg")
                }}>Save</button>}
            </div>
            {(!siteForm?.attr?.accounts?.linkedinOrg || localStorage.getItem("linkedinOrgSelection") === null) && <button className="btn btn-lg btn-link" onClick={() => onCancel("linkedinOrg")}>Claim Later</button>}
        </div>
    </ServiceCardBase>
}

export default LinkedinOrg